// import Firebase - configurazione Globale
import * as firebase from 'firebase/app'; // in caso sia in stato di developer => import * as firebase from 'firebase'; // quindi importare tutto da firebase
import "firebase/storage";
import "firebase/database";

// config Firebase
var config = {
    apiKey: "AIzaSyBWgkbW0vVdaP8cuhHbJJbdtdhRttfaUtE",
    authDomain: "wallpapers-app-7e425.firebaseapp.com",
    databaseURL: "https://wallpapers-app-7e425.firebaseio.com",
    projectId: "wallpapers-app-7e425",
    storageBucket: "wallpapers-app-7e425.appspot.com",
    messagingSenderId: "790915968388",
    appId: "1:790915968388:web:650e0fa35d0821dc2e81d1",
    measurementId: "G-GPZ2C6PYGG"
};
// Initialize Firebase ed esportalo in modo da usare la stessa configurazione ogni volta che se ne ha bisogno
let fire = firebase.initializeApp(config);
export default fire;